export const environment = {
  production: false,
  baseUrl: 'https://staging.ecochem.peerledger.com/api/',
  local: false,
}
